// extracted by mini-css-extract-plugin
export default {"btn":"flexible-request-form_btn__zQyRZ","form_label":"flexible-request-form_form_label__j7XVo"};